(() => {
  'use strict';
  const productMap = pack => new Map(pack.products.map(product => [product.id, product]));
  const amount = (pack, selection) => {
    const products = productMap(pack);
    return selection.reduce((total, selected, slot) => {
      const original = pack.components[slot];
      if (original.technical || selected === undefined) return total;
      return total + (selected ? products.get(selected.id).price * selected.quantity : 0) - products.get(original.id).price * original.quantity;
    }, pack.price);
  };
  const items = (pack, selection) => {
    const products = productMap(pack);
    const bottles = selection.reduce((total, selected) => total + (selected && /^BD/.test(products.get(selected.id)?.sku) ? selected.quantity : 0), 0);
    const entries = pack.components.flatMap((component, slot) => {
      if (component.protector) return bottles ? [{id:component.id, quantity:bottles, price:0, protector:true}] : [];
      const selected = selection[slot];
      return selected ? [{...selected, price:products.get(selected.id).price, box:component.box}] : [];
    }).sort((a, b) => (a.box ? 2 : a.protector ? 1 : 0) - (b.box ? 2 : b.protector ? 1 : 0));
    const protector = entries.find(item => item.protector);
    const box = entries.find(item => item.box);
    if (protector && box && box.quantity === 1 && box.price > protector.quantity) {
      protector.price = 1;
      box.price -= protector.quantity;
    }
    return entries;
  };
  const validate = (pack, selection) => {
    if (selection.some(selected => selected === undefined)) return 'resolve';
    const products = productMap(pack);
    const seen = new Set();
    const foods = [];
    for (let slot = 0; slot < selection.length; slot++) {
      const selected = selection[slot];
      const component = pack.components[slot];
      if (!selected) {if (!component.allowOmit && !component.protector) return 'essential'; continue;}
      if (component.technical) continue;
      const product = products.get(selected.id);
      const identity = product.sku || String(product.id);
      if (seen.has(identity)) return 'duplicates';
      seen.add(identity);
      foods.push(product);
    }
    if (!foods.length) return 'minimum';
    if (pack.kind === 'anchovy' && foods.filter(product => /^AB/.test(product.sku)).length < 2) return 'minimum_anchovy';
    if (pack.kind === 'cheese' && foods.filter(product => /^EQ02[4-8]$/.test(product.sku) || product.sku === 'EQ040').length < 2) return 'minimum_cheese';
    if (pack.kind === 'iberian' && !foods.some(product => /^EQ/.test(product.sku) && product.sku !== 'EQ001')) return 'minimum_iberian';
    if (pack.kind === 'gilda' && !foods.some(product => /^AB/.test(product.sku))) return 'essential';
    return null;
  };
  window.DTPackRules = {amount, items, validate};
})();
